<template>
    <div>
        <el-container class="container" v-show="$route.meta.requiresAuth ">
            <!-- 顶部区域 -->
            <el-header v-if="!$route.meta.hiddenSideMenu">
                <HeaderBar/>
            </el-header>
            <el-container>
                <!-- 侧边菜单 -->
                <div class="sidebar" v-if="!$route.meta.hiddenSideMenu">
                    <SideMenu v-if="$route.meta.requiresAuth"/>
                </div>
                <el-container>
                    <!-- 主体区域 -->
                    <el-main style="margin: 0;padding: 8px 0 0 5px; ">
                        <div style="width: 88vw;height: 90vh;">
                            <router-view v-if="$route.meta.requiresAuth" ></router-view>
                        </div>
                    </el-main>
                </el-container>
            </el-container>
        </el-container>
        <el-container class="container" v-show="!$route.meta.requiresAuth">
            <router-view v-if="!$route.meta.requiresAuth"></router-view>
        </el-container>
    </div>
</template>

<script>
    import SideMenu from "@/views/layout/SideMenu.vue";
    import HeaderBar from "@/views/layout/HeaderBar.vue";
    import Footer from "@/views/layout/Footer.vue";
    import { getToken } from '@/utils/dataStorage.js'
    export default {
        components: {
            HeaderBar,
            SideMenu,
            Footer
        },
        data() {
            return {
                menu: {},
            };
        },
        methods: {

        },
        mounted() {
            /**
             * 每次进入判断是否有token 没有直接返回登录页面
             */
            this.token = getToken();
            if (!this.token) {
                //如果token为空或失效，返回登录界面
                this.$router.push({"name": "login"});
            }
        }
    };
</script>

<style>
    .container {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .sidebar {
        background-color: rgb(48, 65, 86);
        height: 100vh;
        max-width: 11vw;
    }

    .el-main {
        background-color: #e9eef3;

        min-width: 300px;
        height: 100vh;
        max-height: 100vh;
        width: 88vw;
    }

    .el-footer {
        position: absolute;
        display: flex;
        align-items: center;
        text-align: center;
        bottom: 0;
        max-height: 50px;
        min-height: 50px;
    }


</style>
